import React from "react";

import {EntityLogo} from "../../../../core/components/logos/entity-logo";
import {BaseProps} from "../../../../infrastructure/models/props/base-props";
import {CompetitionViewModel} from "../../../../domain/common/competition/models/competition-view-model";
import {DeviceViewModel} from "../../../../core/models/device.view-model";
import {COMPETITIONS_SLIDER_WIDGET} from "../../competition-slider-widget.consts";

export class CompetitionsSliderWidgetItemComponentProps extends BaseProps{
  onChange: Function;
  item: CompetitionViewModel;
  listLength: Number;
  device: DeviceViewModel;
}

export const CompetitionsSliderWidgetDropdownItem = (props: CompetitionsSliderWidgetItemComponentProps) => {
  const onItemClick = () => {
      if(props.onChange){
        props.onChange(props.item);
      }
  }

  const itemContainerProps = {
    className: ['competitions-slider-widget-item-container',(props.listLength === 1) ? 'one-item-competition':''].join(' '),
    onClick: onItemClick
  }

  const logoProps = {
    className: 'competitions-slider-widget-item-logo',
    entity: props.item,
    width: (props.listLength > 1 || props.device.screenWidth < COMPETITIONS_SLIDER_WIDGET.SCREEN_RESOLUTIONS.xs) ? 16 : 48,
    height: (props.listLength > 1 || props.device.screenWidth < COMPETITIONS_SLIDER_WIDGET.SCREEN_RESOLUTIONS.xs) ? 16 : 48
  }

  const textProps ={
    className: ['competitions-slider-widget-item-text',(props.listLength === 1) ? 'one-item-text':''].join(' '),
  }

  return (
    <div {...itemContainerProps}>
      {
        props.item && <EntityLogo {...logoProps}/>
      }
      <div {...textProps}>{props.item?.name}</div>
    </div>
  );
}
